import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=26e4568a"
import script from "./ConfirmAccount.vue?vue&type=script&lang=ts"
export * from "./ConfirmAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e4568a')) {
      api.createRecord('26e4568a', component.options)
    } else {
      api.reload('26e4568a', component.options)
    }
    module.hot.accept("./ConfirmAccount.vue?vue&type=template&id=26e4568a", function () {
      api.rerender('26e4568a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ConfirmAccount.vue"
export default component.exports